import jwtDecode from "jwt-decode";
import { AuthContextProps, AuthProvider, useAuth } from "oidc-react";
import React, { useCallback } from "react";
import { oidcConfig } from ".";

export const AuthenticationCompontent: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (import.meta.env.VITE_DISABLE_AUTH === "true") return <>{children}</>;
  return (
    <AuthProvider {...oidcConfig}>
      <AuthWrapper>{children}</AuthWrapper>
    </AuthProvider>
  );
};

const authLogger = (auth: AuthContextProps | null) => {
  if (import.meta.env.MODE === "development" && auth?.userData?.access_token) {
    const { access_token: accessToken, profile } = auth?.userData;

    let validTill = "";
    try {
      const decoded = new Date(+jwtDecode<{ exp: number }>(accessToken).exp * 1000);
      validTill = new Date(decoded).toISOString();
    } catch (e) {}
    console.log(`\n{"authorization":"Bearer ${accessToken ?? ""}"}

  user: ${profile.name}
  valid until: ${validTill}


  
  `);
  }
};

const AuthWrapper: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const auth = useAuth();
  console.log("auth", auth);
  const secureChildren = useCallback(() => {
    if (!auth?.userData?.access_token) return null;
    authLogger(auth);
    return <>{children}</>;
  }, [auth, children]);
  return secureChildren();
};

export default AuthenticationCompontent;
